// src/components/toolManagment/Admin/routes/Routes.jsx
import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Comp_404 from '../../../../common/404';
import { useSelector } from 'react-redux';
import RoleProtectedRoute from '../../../../routes/RoleProtectedRoute';
import { selectUserData } from '../../../../redux/auth/authSelector';
import { DEFAULT_ROUTES } from '../../../../config/rolePermissions';

// Import components
import Coaches from "../Coaches/index";
import ViewCoach from "../Coaches/View/View";
import AllSessions from "../../AllSessions/Sessions/Session"
import AllSessionsView from "../../AllSessions/Sessions/View"
import SessionMaster from "../Session Master";
import HomeActivity from "../Assignments";
import SupportedDocuments from "../Supported Documents";
import Companies from "../Companies";
import ViewCompany from "../Companies/View";
import QuizMaster from "../QuizMaster";
import Employee from "../../Employee";
import ViewEmployee from "../../Employee/View";
import QuizMasterView from "../QuizMaster/View";
import ProspectCompany from "../ProspectCompany";
import ProspectCompanyView from "../ProspectCompany/view/prospectCompanyView";
import ScienceOfSelf from "../ScienceOfSelf";
import ViewScienceOfSelf from "../ScienceOfSelf/view/ViewScienceOfSelf";
import SalesTrainingCompanies from "../SalesTrainingCompanies";
import ViewSalesTrainingCompany from "../SalesTrainingCompanies/view/ViewSalesTrainingCompany";
import AdhocCompany from "../AdhocComapny";
import ViewAdhocCompany from "../AdhocComapny/View";
import Dashboard from "../../Dashboard";
import SessionList from "../Companies/View/Tabs/Employee/SessionList"
import SessionListView from "../Companies/View/Tabs/Employee/EmployeeSessionView"
import InterViewCandidate from "../Companies/View/Tabs/Interview Candidate/InterView"
import Batches from "../../Batches";
import BatchView from "../../Batches/View/View";
import Management from "../../Hr/Management";
import ViewManagement from "../../Hr/Management/View";
import CompanySession from "../../Hr/CompanySession/CompanySession";
import CompanySessionView from "../../Hr/CompanySession/ViewSession"
import Setting from "../../Setting/setting";
import ResultsOfAssessments from "../../ResultsOfAssessments";
import LearningFeedback from "../LearningFeedback";
import FeedbackViewPage from "../LearningFeedback/FeedbackViewPage";
export const AdminPortalRoutes = () => {
  const userData = useSelector(selectUserData);
  const userRole = userData?.role_name;

  // Get default route for the user's role
  const defaultRoute = DEFAULT_ROUTES[userRole] || '/login';

  return (
    <Routes>
      {/* Root redirect based on role */}
      <Route path="/" element={<Navigate to={defaultRoute} replace />} />

      {/* Dashboard - accessible by both roles */}
      <Route 
        path="dashboard" 
        element={
          <RoleProtectedRoute>
            <Dashboard />
          </RoleProtectedRoute>
        } 
      />

      {/* HR-only routes - Employee management */}
      <Route 
        path="employee" 
        element={
          <RoleProtectedRoute>
            <Employee />
          </RoleProtectedRoute>
        } 
      />
        <Route 
        path="management" 
        element={
          <RoleProtectedRoute>
            <Management />
          </RoleProtectedRoute>
        } 
      />
         <Route 
        path="companySession" 
        element={
          <RoleProtectedRoute>
            <CompanySession />
          </RoleProtectedRoute>
        } 
      />
         <Route 
        path="companySession/view" 
        element={
          <RoleProtectedRoute>
            <CompanySessionView />
          </RoleProtectedRoute>
        } 
      />
        <Route 
        path="sessions" 
        element={
          <RoleProtectedRoute>
            <SessionList />
          </RoleProtectedRoute>
        } 
      />
       <Route 
        path="sessions/view" 
        element={
          <RoleProtectedRoute>
            <SessionListView />
          </RoleProtectedRoute>
        } 
      />
        <Route 
        path="interViewCandidate" 
        element={
          <RoleProtectedRoute>
            <InterViewCandidate />
          </RoleProtectedRoute>
        } 
      />
        
              <Route 
        path="batches" 
        element={
          <RoleProtectedRoute>
            <Batches />
          </RoleProtectedRoute>
        } 
      />
            <Route 
        path="batches/view" 
        element={
          <RoleProtectedRoute>
            <BatchView />
          </RoleProtectedRoute>
        } 
      />
      {/*  */}
      <Route 
        path="employee/view" 
        element={
          <RoleProtectedRoute>
            <ViewEmployee />
          </RoleProtectedRoute>
        } 
      />
  <Route 
        path="management/view" 
        element={
          <RoleProtectedRoute>
            <ViewManagement />
          </RoleProtectedRoute>
        } 
      />
      {/* Admin-only routes */}
      <Route 
        path="companies" 
        element={
          <RoleProtectedRoute>
            <Companies />
          </RoleProtectedRoute>
        } 
      />
      <Route 
        path="companies/companyview" 
        element={
          <RoleProtectedRoute>
            <ViewCompany />
          </RoleProtectedRoute>
        } 
      />
      {/* coach sessions */}
        <Route 
        path="allSessions" 
        element={
          <RoleProtectedRoute>
            <AllSessions />
          </RoleProtectedRoute>
        } 
      />
       <Route 
        path="allSessions/view" 
        element={
          <RoleProtectedRoute>
            <AllSessionsView />
          </RoleProtectedRoute>
        } 
      />
      <Route 
        path="coaches" 
        element={
          <RoleProtectedRoute>
            <Coaches />
          </RoleProtectedRoute>
        } 
      />
      <Route 
        path="coaches/view" 
        element={
          <RoleProtectedRoute>
            <ViewCoach />
          </RoleProtectedRoute>
        } 
      />
      
      <Route 
        path="session-master" 
        element={
          <RoleProtectedRoute>
            <SessionMaster />
          </RoleProtectedRoute>
        } 
      />
      
      <Route 
        path="assignments" 
        element={
          <RoleProtectedRoute>
            <HomeActivity />
          </RoleProtectedRoute>
        } 
      />
      
      <Route 
        path="supported-documents" 
        element={
          <RoleProtectedRoute>
            <SupportedDocuments />
          </RoleProtectedRoute>
        } 
      />
      
      <Route 
        path="quiz-master" 
        element={
          <RoleProtectedRoute>
            <QuizMaster />
          </RoleProtectedRoute>
        } 
      />
      <Route 
        path="quiz-master/quizView" 
        element={
          <RoleProtectedRoute>
            <QuizMasterView />
          </RoleProtectedRoute>
        } 
      />
      
      <Route 
        path="prospectCompany" 
        element={
          <RoleProtectedRoute>
            <ProspectCompany />
          </RoleProtectedRoute>
        } 
      />
      <Route 
        path="prospectCompany/view" 
        element={
          <RoleProtectedRoute>
            <ProspectCompanyView />
          </RoleProtectedRoute>
        } 
      />
      
      <Route 
        path="scienceOfSelf" 
        element={
          <RoleProtectedRoute>
            <ScienceOfSelf />
          </RoleProtectedRoute>
        } 
      />
      <Route
        path="scienceOfSelf/view"
        element={
          <RoleProtectedRoute>
            <ViewScienceOfSelf />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="salesTrainingCompanies"
        element={
          <RoleProtectedRoute>
            <SalesTrainingCompanies />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="salesTrainingCompanies/view"
        element={
          <RoleProtectedRoute>
            <ViewSalesTrainingCompany />
          </RoleProtectedRoute>
        }
      />

      <Route
        path="adhoc-company" 
        element={
          <RoleProtectedRoute>
            <AdhocCompany />
          </RoleProtectedRoute>
        } 
      />
      <Route 
        path="adhoc-company/view" 
        element={
          <RoleProtectedRoute>
            <ViewAdhocCompany />
          </RoleProtectedRoute>
        } 
      />
      <Route
        path="setting"
        element={
          <RoleProtectedRoute>
            <Setting />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="results-of-assessments"
        element={
          <RoleProtectedRoute>
            <ResultsOfAssessments />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="learning-feedback"
        element={
          <RoleProtectedRoute>
            <LearningFeedback />
          </RoleProtectedRoute>
        }
      />
      <Route
        path="learning-feedback/:id"
        element={
          <RoleProtectedRoute>
            <FeedbackViewPage />
          </RoleProtectedRoute>
        }
      />
      {/* Catch all - show 404 page */}
      <Route path="*" element={<Comp_404 />} />
    </Routes>
  );
};